import React from "react";

const Logo = () => {
  return (
    <img
      alt="Logo"
      src="/static/finnize-icon-svg/finnize_white.svg"
      style={{ height: 40 }}
    />
  );
};

export default Logo;
